import { Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { Menu } from '../../shared/menu/menu.model';


@Component({
  selector: 'app-full-menu-header',
  templateUrl: './full-menu-header.component.html',
  styleUrls: ['./full-menu-header.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FullMenuHeaderComponent implements OnInit {
  categoryMenu: Menu;
  @Input() title: string;
  @Input() description: string;
  @Input() menu: Menu;
  @Output() newMenu: EventEmitter<Menu> = new EventEmitter<Menu>();
  

  constructor() {}

  ngOnInit() {
  }

  ngOnChanges() {
    
    if (this.menu)
      this.categoryMenu = this.menu;
  }

  onMenuChange(event){
    this.newMenu.emit(event);
  }

  get menuDescription() {

    const fixedText: string = "Aqui você consegue visualizar todas as opções disponíveis para ";
    if (!this.description)
      return this.description;

    return fixedText + this.description;
  }
}
